// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[2]!./design-system.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[2]!./form-dense.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[2]!./table-compact.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[2]!./overrides.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Main App Styles
 * Built with design system and modern standards
 */

.app {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: var(--slate-50);
}

.main-layout {
  display: flex;
  /* Era \`calc(100vh - 64px)\`: dejaba una franja muerta de 64 px al pie de
     TODAS las pantallas. En móvil además se suma la barra del navegador, así
     que se usa \`dvh\` (alto visible real). */
  height: 100vh;
  height: 100dvh;
}

.layout-container {
  display: flex;
  width: 100%;
  flex: 1 1;
}

.main-content {
  flex: 1 1;
  overflow-y: auto;
  background-color: var(--slate-50);
}

/* Navbar */
.navbar {
  height: 64px;
  background: var(--bg-card);
  border-bottom: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
  flex-shrink: 0;
  z-index: 1030;
  display: flex;
  align-items: center;
  padding: 0 var(--spacing-lg);
  gap: var(--spacing-lg);
}

.navbar-brand {
  font-weight: var(--fw-semibold);
  font-size: var(--text-lg);
  color: var(--text-primary);
  text-decoration: none;
}

.navbar-actions {
  margin-left: auto;
  display: flex;
  gap: var(--spacing-lg);
  align-items: center;
}

/* Loading Spinner */
.spinner-border {
  margin: var(--spacing-2xl) auto;
}

/* Buttons */
.btn {
  border-radius: 0.375rem;
  font-weight: 500;
  transition: all 0.2s ease;
}

.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

/* Forms */
.form-label {
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.form-control,
.form-select {
  border-radius: 0.375rem;
  border: 1px solid #dee2e6;
}

.form-control:focus,
.form-select:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

/* Cards */
.card {
  background: var(--bg-card);
  border: 1px solid var(--border) !important;
  box-shadow: var(--shadow-sm);
  border-radius: 12px;
  transition: all 0.2s ease;
  color: var(--text-primary);
}

.card:hover {
  box-shadow: var(--shadow-md);
  border-color: var(--slate-300) !important;
}

.card-header {
  background: var(--bg-toolbar);
  border-bottom: 1px solid var(--border) !important;
  padding: 1rem;
  color: var(--text-primary);
}

.card-title {
  font-weight: 600;
  margin: 0;
  color: var(--text-primary);
}

/* Badges */
.badge {
  padding: 0.35em 0.65em;
  font-weight: 500;
}

/* Alerts */
.alert {
  border-radius: 10px;
  border: 1px solid var(--border);
  background: var(--bg-toolbar);
  color: var(--text-primary);
}
.alert-success { background: rgba(16,185,129,.12); border-color: rgba(16,185,129,.25); color: #6ee7b7; }
.alert-danger  { background: rgba(239,68,68,.12);  border-color: rgba(239,68,68,.25);  color: #fca5a5; }
.alert-warning { background: rgba(245,158,11,.12); border-color: rgba(245,158,11,.25); color: #fcd34d; }
.alert-info    { background: rgba(6,182,212,.12);  border-color: rgba(6,182,212,.25);  color: #67e8f9; }

/* Tables */
.table {
  margin-bottom: 0;
  color: var(--text-primary);
}

.table-hover tbody tr:hover {
  background-color: var(--bg-toolbar);
}

/* Modals */
.modal {
  background-color: rgba(0, 0, 0, 0.7);
}

.modal-content {
  background: var(--bg-surface);
  border: 1px solid var(--slate-200);
  border-radius: 16px;
  box-shadow: var(--shadow-lg);
  color: var(--text-primary);
}

.modal-header {
  border-bottom: 1px solid var(--border);
  background: var(--bg-toolbar);
  color: var(--text-primary);
}

.modal-footer {
  border-top: 1px solid var(--border);
  background: var(--bg-toolbar);
}

/* Responsive */
@media (max-width: 768px) {
  .main-content {
    padding: 1rem;
  }

  .card {
    margin-bottom: 1rem;
  }
}

/* ══════════════════════════════════════════════════════════════
   GLOBAL DARK OVERRIDES
   Force dark bg on all component-specific toolbars, wrappers,
   modals, dropdowns and forms that still use hardcoded whites.
   ══════════════════════════════════════════════════════════════ */

/* Toolbars / filter bars */
.locations-toolbar, .racks-toolbar, .pel-filters,
.wol-filters, .spt-stats {
  background: var(--bg-toolbar) !important;
  border-color: var(--border) !important;
}

/* Table wrappers */
.locations-table-wrapper, .racks-table-wrapper,
.rack-table-wrapper, .pel-table-wrapper, .wol-table-wrapper,
.audit-container {
  background: var(--bg-card) !important;
  border-color: var(--border) !important;
}

/* Modals / dialogs */
.am-dialog, .cmp-modal, .port-modal,
.app-modal-content, .modal-shell {
  background: var(--bg-surface) !important;
  border: 1px solid var(--slate-200) !important;
  color: var(--text-primary) !important;
}

/* Inline form pages */
.if-shell, .location-form-shell, .server-form-shell,
.location-form-page, .server-form-page {
  background: var(--slate-50) !important;
}

/* Column-toggle / filter dropdowns */
.wol-column-dropdown {
  background: var(--bg-surface) !important;
  border-color: var(--slate-200) !important;
  box-shadow: var(--shadow-md) !important;
}

/* Rack viewer */
.rack-viewer-container {
  background: var(--bg-card) !important;
}

/* AppLauncher panel */
.app-launcher-panel {
  background: var(--bg-surface) !important;
  border-color: var(--slate-200) !important;
}

/* Under construction */
.under-construction {
  background: var(--slate-50) !important;
}

/* DocumentPanel */
.doc-panel-drawer, .doc-panel-inline, .doc-panel-full,
.doc-panel-header, .doc-detail-panel {
  background: var(--bg-surface) !important;
  border-color: var(--border) !important;
}

/* Table rows — global fallback */
.locations-table tbody tr:nth-child(even),
.racks-table tbody tr:nth-child(even),
.pel-table tbody tr:nth-child(even) {
  background-color: var(--bg-toolbar) !important;
}

.locations-table tbody tr:hover td,
.racks-table tbody tr:hover td,
.pel-table tbody tr:hover td {
  background-color: rgba(var(--accent-rgb),.07) !important;
}

/* Text color overrides inside dark containers */
.am-dialog *, .cmp-modal *,
.if-shell *, .location-form-shell *, .server-form-shell * {
  border-color: var(--border);
}

`, "",{"version":3,"sources":["webpack://./src/styles/app.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAOF;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb;;4CAE0C;EAC1C,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,SAAO;AACT;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,WAAW;AACX;EACE,YAAY;EACZ,0BAA0B;EAC1B,sCAAsC;EACtC,4BAA4B;EAC5B,cAAc;EACd,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,+BAA+B;AACjC;;AAEA,YAAY;AACZ;EACE,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;;EAEE,kCAAkC;EAClC,gDAAgD;AAClD;;AAEA,UAAU;AACV;EACE,0BAA0B;EAC1B,0CAA0C;EAC1C,4BAA4B;EAC5B,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,yCAAyC;AAC3C;;AAEA;EACE,6BAA6B;EAC7B,iDAAiD;EACjD,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,0BAA0B;AAC5B;;AAEA,WAAW;AACX;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA,iBAAiB,gCAAgC,EAAE,kCAAkC,EAAE,cAAc,EAAE;AACvG,iBAAiB,+BAA+B,GAAG,iCAAiC,GAAG,cAAc,EAAE;AACvG,iBAAiB,gCAAgC,EAAE,kCAAkC,EAAE,cAAc,EAAE;AACvG,iBAAiB,+BAA+B,GAAG,iCAAiC,GAAG,cAAc,EAAE;;AAEvG,WAAW;AACX;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;AACrC;;AAEA,WAAW;AACX;EACE,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;;;;mEAImE;;AAEnE,2BAA2B;AAC3B;;EAEE,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA,mBAAmB;AACnB;;;EAGE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA,qBAAqB;AACrB;;EAEE,wCAAwC;EACxC,6CAA6C;EAC7C,qCAAqC;AACvC;;AAEA,sBAAsB;AACtB;;EAEE,sCAAsC;AACxC;;AAEA,qCAAqC;AACrC;EACE,wCAAwC;EACxC,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA,gBAAgB;AAChB;EACE,qCAAqC;AACvC;;AAEA,sBAAsB;AACtB;EACE,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA,uBAAuB;AACvB;EACE,sCAAsC;AACxC;;AAEA,kBAAkB;AAClB;;EAEE,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA,iCAAiC;AACjC;;;EAGE,8CAA8C;AAChD;;AAEA;;;EAGE,wDAAwD;AAC1D;;AAEA,gDAAgD;AAChD;;EAEE,2BAA2B;AAC7B","sourcesContent":["/**\r\n * Main App Styles\r\n * Built with design system and modern standards\r\n */\r\n\r\n@import './design-system.css';\r\n@import './form-dense.css';\r\n@import './table-compact.css';\r\n@import './overrides.css';\r\n\r\n.app {\r\n  width: 100%;\r\n  height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  background-color: var(--slate-50);\r\n}\r\n\r\n.main-layout {\r\n  display: flex;\r\n  /* Era `calc(100vh - 64px)`: dejaba una franja muerta de 64 px al pie de\r\n     TODAS las pantallas. En móvil además se suma la barra del navegador, así\r\n     que se usa `dvh` (alto visible real). */\r\n  height: 100vh;\r\n  height: 100dvh;\r\n}\r\n\r\n.layout-container {\r\n  display: flex;\r\n  width: 100%;\r\n  flex: 1;\r\n}\r\n\r\n.main-content {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  background-color: var(--slate-50);\r\n}\r\n\r\n/* Navbar */\r\n.navbar {\r\n  height: 64px;\r\n  background: var(--bg-card);\r\n  border-bottom: 1px solid var(--border);\r\n  box-shadow: var(--shadow-sm);\r\n  flex-shrink: 0;\r\n  z-index: 1030;\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 0 var(--spacing-lg);\r\n  gap: var(--spacing-lg);\r\n}\r\n\r\n.navbar-brand {\r\n  font-weight: var(--fw-semibold);\r\n  font-size: var(--text-lg);\r\n  color: var(--text-primary);\r\n  text-decoration: none;\r\n}\r\n\r\n.navbar-actions {\r\n  margin-left: auto;\r\n  display: flex;\r\n  gap: var(--spacing-lg);\r\n  align-items: center;\r\n}\r\n\r\n/* Loading Spinner */\r\n.spinner-border {\r\n  margin: var(--spacing-2xl) auto;\r\n}\r\n\r\n/* Buttons */\r\n.btn {\r\n  border-radius: 0.375rem;\r\n  font-weight: 500;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.btn:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* Forms */\r\n.form-label {\r\n  font-weight: 600;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.form-control,\r\n.form-select {\r\n  border-radius: 0.375rem;\r\n  border: 1px solid #dee2e6;\r\n}\r\n\r\n.form-control:focus,\r\n.form-select:focus {\r\n  border-color: var(--primary-color);\r\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\r\n}\r\n\r\n/* Cards */\r\n.card {\r\n  background: var(--bg-card);\r\n  border: 1px solid var(--border) !important;\r\n  box-shadow: var(--shadow-sm);\r\n  border-radius: 12px;\r\n  transition: all 0.2s ease;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.card:hover {\r\n  box-shadow: var(--shadow-md);\r\n  border-color: var(--slate-300) !important;\r\n}\r\n\r\n.card-header {\r\n  background: var(--bg-toolbar);\r\n  border-bottom: 1px solid var(--border) !important;\r\n  padding: 1rem;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.card-title {\r\n  font-weight: 600;\r\n  margin: 0;\r\n  color: var(--text-primary);\r\n}\r\n\r\n/* Badges */\r\n.badge {\r\n  padding: 0.35em 0.65em;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Alerts */\r\n.alert {\r\n  border-radius: 10px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-primary);\r\n}\r\n.alert-success { background: rgba(16,185,129,.12); border-color: rgba(16,185,129,.25); color: #6ee7b7; }\r\n.alert-danger  { background: rgba(239,68,68,.12);  border-color: rgba(239,68,68,.25);  color: #fca5a5; }\r\n.alert-warning { background: rgba(245,158,11,.12); border-color: rgba(245,158,11,.25); color: #fcd34d; }\r\n.alert-info    { background: rgba(6,182,212,.12);  border-color: rgba(6,182,212,.25);  color: #67e8f9; }\r\n\r\n/* Tables */\r\n.table {\r\n  margin-bottom: 0;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.table-hover tbody tr:hover {\r\n  background-color: var(--bg-toolbar);\r\n}\r\n\r\n/* Modals */\r\n.modal {\r\n  background-color: rgba(0, 0, 0, 0.7);\r\n}\r\n\r\n.modal-content {\r\n  background: var(--bg-surface);\r\n  border: 1px solid var(--slate-200);\r\n  border-radius: 16px;\r\n  box-shadow: var(--shadow-lg);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.modal-header {\r\n  border-bottom: 1px solid var(--border);\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.modal-footer {\r\n  border-top: 1px solid var(--border);\r\n  background: var(--bg-toolbar);\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n  .main-content {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .card {\r\n    margin-bottom: 1rem;\r\n  }\r\n}\r\n\r\n/* ══════════════════════════════════════════════════════════════\r\n   GLOBAL DARK OVERRIDES\r\n   Force dark bg on all component-specific toolbars, wrappers,\r\n   modals, dropdowns and forms that still use hardcoded whites.\r\n   ══════════════════════════════════════════════════════════════ */\r\n\r\n/* Toolbars / filter bars */\r\n.locations-toolbar, .racks-toolbar, .pel-filters,\r\n.wol-filters, .spt-stats {\r\n  background: var(--bg-toolbar) !important;\r\n  border-color: var(--border) !important;\r\n}\r\n\r\n/* Table wrappers */\r\n.locations-table-wrapper, .racks-table-wrapper,\r\n.rack-table-wrapper, .pel-table-wrapper, .wol-table-wrapper,\r\n.audit-container {\r\n  background: var(--bg-card) !important;\r\n  border-color: var(--border) !important;\r\n}\r\n\r\n/* Modals / dialogs */\r\n.am-dialog, .cmp-modal, .port-modal,\r\n.app-modal-content, .modal-shell {\r\n  background: var(--bg-surface) !important;\r\n  border: 1px solid var(--slate-200) !important;\r\n  color: var(--text-primary) !important;\r\n}\r\n\r\n/* Inline form pages */\r\n.if-shell, .location-form-shell, .server-form-shell,\r\n.location-form-page, .server-form-page {\r\n  background: var(--slate-50) !important;\r\n}\r\n\r\n/* Column-toggle / filter dropdowns */\r\n.wol-column-dropdown {\r\n  background: var(--bg-surface) !important;\r\n  border-color: var(--slate-200) !important;\r\n  box-shadow: var(--shadow-md) !important;\r\n}\r\n\r\n/* Rack viewer */\r\n.rack-viewer-container {\r\n  background: var(--bg-card) !important;\r\n}\r\n\r\n/* AppLauncher panel */\r\n.app-launcher-panel {\r\n  background: var(--bg-surface) !important;\r\n  border-color: var(--slate-200) !important;\r\n}\r\n\r\n/* Under construction */\r\n.under-construction {\r\n  background: var(--slate-50) !important;\r\n}\r\n\r\n/* DocumentPanel */\r\n.doc-panel-drawer, .doc-panel-inline, .doc-panel-full,\r\n.doc-panel-header, .doc-detail-panel {\r\n  background: var(--bg-surface) !important;\r\n  border-color: var(--border) !important;\r\n}\r\n\r\n/* Table rows — global fallback */\r\n.locations-table tbody tr:nth-child(even),\r\n.racks-table tbody tr:nth-child(even),\r\n.pel-table tbody tr:nth-child(even) {\r\n  background-color: var(--bg-toolbar) !important;\r\n}\r\n\r\n.locations-table tbody tr:hover td,\r\n.racks-table tbody tr:hover td,\r\n.pel-table tbody tr:hover td {\r\n  background-color: rgba(var(--accent-rgb),.07) !important;\r\n}\r\n\r\n/* Text color overrides inside dark containers */\r\n.am-dialog *, .cmp-modal *,\r\n.if-shell *, .location-form-shell *, .server-form-shell * {\r\n  border-color: var(--border);\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
